import React from 'react';

const TimeZoneView = () => {
    return (
        <div className='h-screen w-full items-center flex justify-center text-center'>
            <div>
                <h1 className='text-2xl font-bold space-x-0 font-public-sans'>Check your device timezone <span className='text-green-700'>(UTC+5:45) Kathmandu</span></h1>
                <h6 className='font-public-sans text-lg'>Sorry, we can't find the page you are looking for.:(</h6>
            </div>
        </div>
    )
}

export default TimeZoneView